import { ArrowDown, ArrowUp } from 'lucide-react';
import React from 'react';

import { cn } from '../../lib/utils';
import { useTranslation } from 'react-i18next';

interface KPICardProps {
  title: string;
  value: string | number;
  change?: {
    value: number;
    isPositive: boolean;
  };
  icon?: React.ElementType;
  className?: string;
  onClick?: () => void;
}

export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  change,
  icon: Icon,
  className,
  onClick
}) => {
  const { t } = useTranslation();
  
  const CardContent = (
    <>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <div className="flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground">{value}</span>
            {change && (
              <div className={cn(
                "flex items-center gap-1 text-sm font-medium",
                change.value === 0 ? "text-red-600" : "text-green-600"
              )}>
                {change.value === 0 ? (
                  <ArrowDown className="h-3 w-3" />
                ) : (
                  <ArrowUp className="h-3 w-3" />
                )}
                <span>{Math.abs(change.value)} {t('dashboard.thisWeek')}</span>
              </div>
            )}
          </div>
        </div>
        {Icon && (
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon className="h-6 w-6 text-primary" />
          </div>
        )}
      </div>
    </>
  );

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={cn(
          "bg-card border border-border rounded-xl p-6 w-full text-left transition-all hover:border-primary hover:shadow-lg hover:scale-105 cursor-pointer",
          className
        )}
      >
        {CardContent}
      </button>
    );
  }
  
  return (
    <div className={cn(
      "bg-card border border-border rounded-xl p-6",
      className
    )}>
      {CardContent}
    </div>
  );
};
